import { useRoutingStore } from '../stores/routingStore'
import { MainMenuSection } from '../components/MainMenu/types/MainMenu.types'

// Utility functions for routing navigation
export const routingUtils = {
  // Navigate to a specific section
  navigateToSection: (section: MainMenuSection) => {
    const store = useRoutingStore.getState()
    store.navigateToSection(section)
  },

  // Navigate to a specific path
  navigateToPath: (path: string) => {
    const store = useRoutingStore.getState()
    store.navigateTo(path)
  },

  // Get current section
  getCurrentSection: (): MainMenuSection => {
    const store = useRoutingStore.getState()
    return store.currentSection
  },

  // Get current path
  getCurrentPath: (): string => {
    const store = useRoutingStore.getState()
    return store.currentPath
  },

  // Check if a section is currently active
  isSectionActive: (section: MainMenuSection): boolean => {
    const store = useRoutingStore.getState()
    return store.currentSection === section
  },

  // Check if a path is currently active
  isPathActive: (path: string): boolean => {
    const store = useRoutingStore.getState()
    return store.currentPath === path
  },

  // Navigate back
  goBack: () => {
    const store = useRoutingStore.getState()
    store.goBack()
  },

  // Navigate forward
  goForward: () => {
    const store = useRoutingStore.getState()
    store.goForward()
  },

  // Check if can go back
  canGoBack: (): boolean => {
    const store = useRoutingStore.getState()
    return store.canGoBack()
  },

  // Check if can go forward
  canGoForward: (): boolean => {
    const store = useRoutingStore.getState()
    return store.canGoForward()
  },

  // Company Management Navigation
  company: {
    navigateToOverview: () => routingUtils.navigateToSection('companyOverview'),
    navigateToDashboard: () => routingUtils.navigateToSection('companyDashboard'),
    navigateToSetup: () => routingUtils.navigateToSection('companySetup'),
    navigateToBilling: () => routingUtils.navigateToSection('companyBilling'),
    navigateToUsers: () => routingUtils.navigateToSection('companyUsers'),
    navigateToSettings: () => routingUtils.navigateToSection('companySettings'),
    navigateToMain: () => routingUtils.navigateToSection('companyManagement'),
  },

  // Admin Navigation
  admin: {
    navigateToDashboard: () => routingUtils.navigateToSection('adminDashboard'),
    navigateToEnvironment: () => routingUtils.navigateToSection('adminEnvironmentConfig'),
    navigateToEntities: () => routingUtils.navigateToSection('adminEntityCatalogue'),
    navigateToRooms: () => routingUtils.navigateToSection('adminAllRooms'),
    navigateToBilling: () => routingUtils.navigateToSection('adminBillingSettings'),
    navigateToRoomManagement: () => routingUtils.navigateToSection('adminRoomManagement'),
    navigateToMapEditorPlugins: () => routingUtils.navigateToSection('adminMapEditorPlugins'),
    navigateToProductUpdates: () => routingUtils.navigateToSection('adminProductUpdates'),
    navigateToMain: () => routingUtils.navigateToSection('adminMenu'),
  },

  // Dialog Navigation
  dialogs: {
    openCompanyDialog: () => routingUtils.navigateToSection('companyDialog'),
    openInviteUserDialog: () => routingUtils.navigateToSection('inviteUserDialog'),
    openEditUserDialog: () => routingUtils.navigateToSection('editUserDialog'),
    openUsersDialog: () => routingUtils.navigateToSection('usersDialog'),
    openCompanyRoomsDialog: () => routingUtils.navigateToSection('companyRoomsDialog'),
  },

  // Main Navigation
  main: {
    navigateToDashboard: () => routingUtils.navigateToSection('publicLobby'),
    navigateToRooms: () => routingUtils.navigateToSection('myRooms'),
    navigateToProfile: () => routingUtils.navigateToSection('profile'),
    navigateToSettings: () => routingUtils.navigateToSection('settings'),
  },
}

export default routingUtils
